import _ from 'underscore';
import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode } from 'react';
import { Container, Header } from 'semantic-ui-react';

import { Flexbox } from './Flexbox';
import { FlexItem, FlexItemProps } from './FlexItem';

import { StyledContainer } from './StyledContainer';
import { CorvalStylizedHexContainer } from '../components/product/CorvalStylizedHexContainer';
import { CorvalUIColor, FlexAlign, FlexJustify, Position, SemanticUIColor, SemanticUISize, Size } from '../../types/componentPropTypes';
import { useUIDisplayModes } from '../../hooks';
import { ClassValue } from 'classnames/types';


interface PageTitleContainerProps {
    title?: string,
    titleTooltip?: ReactNode,
    description?: ReactNode | string,
    fluid?: boolean,
    alignContent?: FlexAlign,
    verticalPadding?: Size,
    //leftBasisWidth?: NumberRange0to100,
    leftFlexItemProps?: FlexItemProps,
    rightFlexItemProps?: FlexItemProps,
    hideOnMinimization?: boolean,
    className?: ClassValue,
    style?: CSSProperties,
    shrinkTitle?: boolean

}

const defaultProps: PageTitleContainerProps = {
    title: null,
    description: null,
    fluid: false,
    alignContent: FlexAlign.END,
    verticalPadding: Size.MD,
    hideOnMinimization: false,
    className: null,
    leftFlexItemProps: { basis: 30 },
    rightFlexItemProps: {},
    style: {},
    shrinkTitle: false
}

const PageTitleContainerWrapper: FC = (props) => (
    <StyledContainer className={'padding-lg-horizontal'}>{props.children}</StyledContainer>
);

const PageTitleContainer: FC<PageTitleContainerProps> = ({ children, ...props }) => {

    let { minimizedChrome } = useUIDisplayModes();

    let WrapperContainer = (props.fluid)
        ? PageTitleContainerWrapper
        : Container;

    if (props.hideOnMinimization && minimizedChrome) return null;

    return (
        <>
            <StyledContainer position={Position.RELATIVE}
                bgColor={CorvalUIColor.WHITE}
                borderColor={SemanticUIColor.TEAL}
                className={classNames(
                    'layout--frame-page-title-container',
                    `border-md-bottom`,
                    [`padding-${props.verticalPadding}-vertical`],
                    props.className
                )}
                style={props.style}>

                <CorvalStylizedHexContainer fill={'area'} size={SemanticUISize.MINI} />

                <WrapperContainer>

                    {_.isFunction(children)

                        ? children(minimizedChrome)

                        : <Flexbox align={props.alignContent}
                            justify={FlexJustify.SPACE_BETWEEN}
                            style={{ columnGap: props.shrinkTitle ? 5 : 50 }} >

                            <FlexItem {...props.leftFlexItemProps}>

                                {props.title && (
                                    <Header as={minimizedChrome ? 'h5' : 'h3'} color={SemanticUIColor.BLUE} className={'text--normal no-margin'}>
                                        {props.title}
                                        {props.titleTooltip && (
                                            <StyledContainer className={'display--inline-block text--md'}>
                                                {props.titleTooltip}
                                            </StyledContainer>
                                        )}
                                    </Header>
                                )}

                                {/* {props.title && props.shrinkTitle && (
                                        React.createElement(
                                            minimizedChrome ? 'h5' : 'h3',
                                            { className: 'text--normal no-margin' },
                                            <>
                                                {props.title}
                                                {props.titleTooltip && (
                                                    <div className="display--inline-block text--md">
                                                        {props.titleTooltip}
                                                    </div>
                                                )}
                                            </>
                                        )
                                )} */}
                                {!minimizedChrome && props.description && <p className={'text--sm text--colored-lightBlue no-margin-bottom'}>{props.description}</p>}

                            </FlexItem>

                            {children && (
                                <FlexItem className={classNames('position--relative', props.rightFlexItemProps.className ?? {})} {..._.omit(props.rightFlexItemProps, 'className')}>

                                    {children}

                                </FlexItem>
                            )}

                        </Flexbox>
                    }

                </WrapperContainer>

            </StyledContainer>
        </>
    )
};

PageTitleContainer.defaultProps = defaultProps;

export { PageTitleContainer }
